import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1.5rem;

  .aviso {
    margin-bottom: 1rem;
  }
`;
